import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import './style.css';
import { Row, Col, Button } from 'react-bootstrap';
import TeamCards from './TeamCards';
import MatchupCards from './MatchupCards';
import Legend from './legend';
import UserHeader from '../UserHeader';
import NBACoverImg from './img/nbaLandingPageCoverMobile.png';
import CKCoverImg from './img/ckLandingPageCoverMobile.png';

import { Event } from '../Tracking';
import PlayerCards from './PlayerCards';
import nfllogo from './img/nfl.png';
import nbalogo from './img/NBA.png';
import cricketLogo from './img/IPL.png';
import BreakingNews from '../BreakingNews';
import ArticlesTab from './ArticlesTab';
import { request } from '../utils';

function UpcomingGames(props) {
	const { schedules, teams, playersInfo, match, user, purchasePlan, dispatch, freeAccess, sources, options, assignCurrentSport, page,AggregatedNews } = props;
	//console.log(props,'props')
	let { sport } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const pathnameSport = location.pathname.split('/')[1]?.toUpperCase();
	const queryParams = new URLSearchParams(location.search);
	const league = queryParams.get("league");
	const normalizedSport = sport?.toUpperCase() || pathnameSport || page?.toUpperCase() || '';

	const nflPage = normalizedSport === 'NFL';
	const nbaPage = normalizedSport === 'NBA';
	const soccerPage = normalizedSport === 'SOCCER';
	const cricketPage = normalizedSport === 'CRICKET' || league?.toUpperCase() === 'IPL';
	const landingCoverImg = cricketPage ? CKCoverImg : NBACoverImg;
	const landingCoverAlt = cricketPage ? 'Cricket Player' : 'NBA Player';
	const params = new URLSearchParams(location.search);
	const season = params.get("season");

	


	const nflScoreboard = options?.data?.nflScoreboard;
	let nflScoreboardData = {
		profit: 0,
		wins: 0,
		winsPercentage: 0
	};
	if (nflScoreboard && nflPage) {
		nflScoreboard.map((s) => {
			nflScoreboardData.profit = nflScoreboardData.profit + s.payout_amount_bet;
			if (s.win) {
				nflScoreboardData.wins = nflScoreboardData.wins + 1;
			}
			return nflScoreboardData;
		});
		nflScoreboardData.winsPercentage = ((nflScoreboardData.wins / nflScoreboard?.length) * 100).toFixed(1);
		nflScoreboardData.profit = Math.floor(nflScoreboardData.profit);
	}

	const getViewFromQuery = () => {
		const query = new URLSearchParams(location.search);
		const view = query.get('view');
		return {
			showSchedules: !view || view === 'schedules',
			showTeams: view === 'teams',
			showPlayers: view === 'players',
			showArticles: view === 'articles',
		};
	};

	const [showSchedules, handleShowSchedules] = useState(getViewFromQuery().showSchedules);
	const [showTeams, handleShowTeams] = useState(getViewFromQuery().showTeams);
	const [showPlayers, handleShowPlayers] = useState(getViewFromQuery().showPlayers);
	const [showArticles, handleShowArticles] = useState(getViewFromQuery().showArticles);
	const lastRequestedCursorRef = useRef(null);
	const appendInFlightRef = useRef(false);
	const lastScrollCheckAtRef = useRef(0);
	const cricketLastRequestedCursorRef = useRef(null);
	const cricketAppendInFlightRef = useRef(false);
	const [cricketPlayers, setCricketPlayers] = useState([]);
	const [cricketPagination, setCricketPagination] = useState(null);
	const [cricketLoading, setCricketLoading] = useState(false);
	const [cricketTeams, setCricketTeams] = useState([]);
	const [cricketTeamsPagination, setCricketTeamsPagination] = useState(null);
	const [cricketTeamsLoading, setCricketTeamsLoading] = useState(false);

	const normalizeCricketTeam = (team = {}) => {
		const normalizedHealthScore =
			team.team_gaming_score ??
			team.healthScore ??
			team.health_score ??
			team.teamHealthScore ??
			team.team_health_score;

		if (normalizedHealthScore == null) {
			return team;
		}

		return {
			...team,
			team_gaming_score: normalizedHealthScore,
			healthScore: normalizedHealthScore
		};
	};
	
	// Update state when location.search changes
	useEffect(() => {
		const { showSchedules, showTeams, showPlayers, showArticles } = getViewFromQuery();
		handleShowSchedules(showSchedules);
		handleShowTeams(showTeams);
		handleShowPlayers(showPlayers);
		handleShowArticles(showArticles);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.search]);

	const setTab = (tab) => {
		const params = new URLSearchParams(location.search);
		params.set('view', tab);
		navigate({ search: params.toString() }, { replace: false });
	};

	useEffect(() => {
		window.scrollTo(0, 0);
		lastRequestedCursorRef.current = null;

		assignCurrentSport();

		if (!schedules.data) {
			dispatch({ type: 'GET_SCHEDULES',payload: { league, season } });
		}
		if (match.match) {
			dispatch({ type: 'CLEAR_MATCH' });
		}
		const query = new URLSearchParams(window.location.search);

		if (query.get('teamView')?.toUpperCase() === 'TRUE') {
			handleShowTeams(true);
			handleShowSchedules(false);
			handleShowPlayers(false);
			setTab('teams');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		lastRequestedCursorRef.current = null;
		appendInFlightRef.current = false;
	}, [league, season, cricketPage]);

	// Fetch cricket players using cursor-based /api/cricket/players API
	const fetchCricketPlayers = async ({ cursor: playersCursor, append } = {}) => {
		if (!cricketPage || cricketLoading) return;
		setCricketLoading(true);
		cricketAppendInFlightRef.current = !!append;

		try {
			const params = new URLSearchParams();
			params.set('league', league || 'IPL');
			params.set('limit', '50');
			if (playersCursor) params.set('cursor', playersCursor);

			const res = await request({}, `/api/cricket/players?${params.toString()}`, 'GET', user?.token);
			const data = res?.data?.data || {};
			const newPlayers = data.playerInfo || [];
			const pagination = data.pagination || null;

			setCricketPlayers((prev) => (append ? [ ...prev, ...newPlayers ] : newPlayers));
			setCricketPagination(pagination);
		} catch (e) {
			// silently fail; existing players will remain
		} finally {
			setCricketLoading(false);
			cricketAppendInFlightRef.current = false;
		}
	};

	// Fetch cricket teams using /cricket/teams API
	const fetchCricketTeams = async ({ cursor: teamsCursor } = {}) => {
		if (!cricketPage || cricketTeamsLoading) return;
		setCricketTeamsLoading(true);

		try {
			const params = new URLSearchParams();
			params.set('limit', '50');
			if (teamsCursor) params.set('cursor', teamsCursor);

			const res = await request({}, `/cricket/teams?${params.toString()}`, 'GET', user?.token);
			const data = res?.data?.data || {};
			const newTeams = (data.teams || []).map(normalizeCricketTeam);
			const pagination = data.pagination || null;

			setCricketTeams(newTeams);
			setCricketTeamsPagination(pagination);
		} catch (e) {
			// silently fail; existing teams will remain
		} finally {
			setCricketTeamsLoading(false);
		}
	};

	useEffect(() => {
		if (!schedules?.isAppending) {
			appendInFlightRef.current = false;
		}
	}, [schedules?.isAppending]);

	// Reset cricket players pagination when league/season/cricketPage changes
	useEffect(() => {
		if (!cricketPage) {
			setCricketPlayers([]);
			setCricketPagination(null);
			cricketLastRequestedCursorRef.current = null;
			cricketAppendInFlightRef.current = false;
			setCricketTeams([]);
			setCricketTeamsPagination(null);
			return;
		}
		if (showPlayers) {
			setCricketPlayers([]);
			setCricketPagination(null);
			cricketLastRequestedCursorRef.current = null;
			cricketAppendInFlightRef.current = false;
			fetchCricketPlayers({ append: false });
		}
		if (showTeams) {
			setCricketTeams([]);
			setCricketTeamsPagination(null);
			fetchCricketTeams();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cricketPage, showPlayers, showTeams, league]);

	useEffect(() => {
		if (!cricketPage || !showSchedules) return;

		const onScroll = () => {
			const now = Date.now();
			if (now - lastScrollCheckAtRef.current < 200) return;
			lastScrollCheckAtRef.current = now;

			const hasMore = Boolean(schedules?.data?.pagination?.hasMore);
			const nextCursor = schedules?.data?.pagination?.nextCursor;
			if (!hasMore || !nextCursor || schedules?.isAppending || appendInFlightRef.current) return;

			const cardsEndEl = document.querySelector('#cardRow') || document.querySelector('.cardSection');
			if (cardsEndEl) {
				const cardsBottom = cardsEndEl.getBoundingClientRect().bottom + window.scrollY;
				const reachedCardsEnd = window.scrollY + window.innerHeight >= cardsBottom - 80;
				if (!reachedCardsEnd) return;
			} else {
				const nearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 120;
				if (!nearBottom) return;
			}

			if (lastRequestedCursorRef.current === nextCursor) return;
			lastRequestedCursorRef.current = nextCursor;
			appendInFlightRef.current = true;

			dispatch({
				type: 'GET_SCHEDULES',
				payload: {
					league: league || 'IPL',
					season,
					limit: 20,
					cursor: nextCursor,
					append: true
				}
			});
		};

		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, [cricketPage, showSchedules, schedules?.data?.pagination?.hasMore, schedules?.data?.pagination?.nextCursor, schedules?.isAppending, dispatch, league, season]);

	// Infinite scroll for cricket players using cursor-based API
	useEffect(() => {
		if (!cricketPage || !showPlayers) return;

		const onScrollPlayers = () => {
			const now = Date.now();
			if (now - lastScrollCheckAtRef.current < 200) return;
			lastScrollCheckAtRef.current = now;

			const hasMore = Boolean(cricketPagination?.hasMore);
			const nextCursor = cricketPagination?.nextCursor;
			if (!hasMore || !nextCursor || cricketAppendInFlightRef.current) return;

			const cardsEndEl = document.querySelector('#cardRow') || document.querySelector('.cardSection');
			if (cardsEndEl) {
				const cardsBottom = cardsEndEl.getBoundingClientRect().bottom + window.scrollY;
				const reachedCardsEnd = window.scrollY + window.innerHeight >= cardsBottom - 80;
				if (!reachedCardsEnd) return;
			} else {
				const nearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 120;
				if (!nearBottom) return;
			}

			if (cricketLastRequestedCursorRef.current === nextCursor) return;
			cricketLastRequestedCursorRef.current = nextCursor;
			cricketAppendInFlightRef.current = true;

			fetchCricketPlayers({ cursor: nextCursor, append: true });
		};

		window.addEventListener('scroll', onScrollPlayers, { passive: true });
		return () => window.removeEventListener('scroll', onScrollPlayers);
	}, [cricketPage, showPlayers, cricketPagination]);

	const loadMoreCricketNews = async ({ offset = 0, limit = 6 } = {}) => {
		try {
			const params = new URLSearchParams();
			params.set('league', league || 'IPL');
			if (season) params.set('season', season);
			params.set('newsOffset', `${offset}`);
			params.set('newsLimit', `${limit}`);

			const res = await request({}, `/api/cricket/schedules?${params.toString()}`, 'GET', user?.token);
			const data = res?.data?.data || {};
			const items = Array.isArray(data?.AggregatedNews) ? data.AggregatedNews : [];
			const pagination = data?.newsPagination || {};

			return {
				items,
				hasMore: Boolean(pagination?.hasMore),
				nextOffset: Number.isFinite(Number(pagination?.nextOffset)) ? Number(pagination.nextOffset) : offset + items.length
			};
		} catch (e) {
			return {
				items: [],
				hasMore: false,
				nextOffset: offset
			};
		}
	};

	const { sportsID, sportsName } = user;
	const title = showTeams ? `Teams Dashboard` : `The Matchup Edge`;
	if (!schedules && !teams) return null;
	if (schedules.data && !schedules.data.schedules && teams.data && !teams.data.teamInfo && !schedules?.isLoading) {
		return (
			<React.Fragment>
				<div className='desktopUserheader'>{user && user.name && <UserHeader username={user.name} title={title} />}</div>
				<div className='mobileUserheader'>{user && user.name && <UserHeader username={user.name} title={title} />}</div>
				<div id='fullHeight'>
					<div id='loading' />
				</div>
			</React.Fragment>
		);
	}

	const isInitialSchedulesLoading = Boolean(schedules?.isLoading && !schedules?.data?.schedules?.length);
	if (user.isLoading || purchasePlan.isLoading || isInitialSchedulesLoading || freeAccess?.isLoading) {
		return (
			<div id='fullHeight'>
				<div id='loading' />
			</div>
		);
	}

	if (purchasePlan.isLoaded && !purchasePlan.error) {
		window.location.reload();
	}

	const teamInfo = cricketPage && showTeams ? cricketTeams : teams && teams.data && teams.data.teamInfo;
	const playerInfo = cricketPage && showPlayers ? cricketPlayers : playersInfo?.playersInfo;
	const showSportsInfo = cricketPage || Boolean(options?.data?.sportsInfo?.form_display);
	const articleCategory =
		cricketPage ? 'IPL' :
		soccerPage && league?.toUpperCase() === 'EPL' ? 'EPL' :
		soccerPage && league?.toUpperCase() === 'ESP' ? 'La Liga' :
		sport?.toUpperCase() || page?.toUpperCase() || '';

	return (
		<div>
			{/* 1. Upcoming Games, Teams, Players, Matchup */}
			<section className='cardSection container-fluid'>
				{showSportsInfo ? (
					<Row>
						<Col lg={12}>							
							{/* {(nbaPage || soccerPage || league === "EPL" || league === "ESP") && (
								<div style={{ color: '#888', fontWeight: 'bold', margin: '10px 0' }}>Coming Soon</div>
							)} */}
							<div className='cardTypeDiv'>
								<Button
									className={`cardTypeButton ${showSchedules ? 'cardTypeButtonActive' : ''}`}
									active={showSchedules}
									// disabled={nbaPage || soccerPage || league === "EPL" || league === "ESP"}
									onClick={() => {
										Event(sources?.source, 'VIEW_SCHEDULES', 'VIEW_SCHEDULES_BUTTON');
										if (!showSchedules) setTab('schedules');
										dispatch({
											type: 'AUDIT',
											payload: { action: 'VIEW_SCHEDULES' }
										});
									}}
								>
									Upcoming Games
								</Button>
								<Button
									className={`cardTypeButton ${showTeams ? 'cardTypeButtonActive' : ''}`}
									active={showTeams}
									// disabled={nbaPage || soccerPage || league === "EPL" || league === "ESP"}
									onClick={() => {
										Event(sources?.source, 'VIEW_TEAMS', 'VIEW_TEAMS_BUTTON');
										if (!showTeams) setTab('teams');
										dispatch({
											type: 'AUDIT',
											payload: { action: 'VIEW_TEAMS' }
										});
									}}
								>
									Teams
								</Button>
								<Button
									className={`cardTypeButton ${showPlayers ? 'cardTypeButtonActive' : ''}`}
									active={showPlayers}
									// disabled={nbaPage || soccerPage || league === "EPL" || league === "ESP"}
									onClick={() => {
										Event(sources?.source, 'VIEW_PLAYERS', 'VIEW_PLAYERS_BUTTON');
										if (!showPlayers) setTab('players');
										dispatch({
											type: 'AUDIT',
											payload: { action: 'VIEW_PLAYERS' }
										});
									}}
								>
									Players
								</Button>
								<Button
									className={`cardTypeButton ${showArticles ? 'cardTypeButtonActive' : ''}`}
									active={showArticles}
									onClick={() => {
										Event(sources?.source, 'VIEW_INSIGHTS', 'VIEW_INSIGHTS_BUTTON');
										if (!showArticles) setTab('articles');
										dispatch({
											type: 'AUDIT',
											payload: { action: 'VIEW_INSIGHTS' }
										});
									}}
								>
									Insights
								</Button>
							</div>
						</Col>
					</Row>
				) : null}
				<Row id='cardRow' className='cardRow' style={{ paddingTop: `${showTeams ? '45px' : ''}` }}>
					{showSchedules && (
						<>
							{nbaPage ? (
								<>
									<Col lg={4}>
										<h1 className='matchupCardsHeader'>Schedules</h1>
									</Col>
									<Col lg={8}></Col>
								</>
							) : null}
							<MatchupCards match={match} teams={teamInfo} sportsID={sportsID} sportsName={sportsName} nflPage={nflPage} nbaPage={nbaPage || cricketPage} />
						</>
					)}
					{showTeams && <TeamCards teams={teamInfo} sportsID={sportsID} sportsName={sportsName} nbaPage={nbaPage || cricketPage}/>}
					{showPlayers && <PlayerCards sportsName={sportsName} players={playerInfo} nbaPage={nbaPage || cricketPage}/>}
					{showArticles && (
						<Col lg={12}>
							<div className="articles-tab-container">
								<ArticlesTab
									key={articleCategory || 'all-articles'}
									currentSport={articleCategory}
								/>
							</div>
						</Col>
					)}
				</Row>
			</section>

			{/* 2. Legend Section */}
			<section className='dashboardLegend container-fluid'>
				<hr className='hrStyle' />
				<Row className='dashboardLegendRow'>
					<Col lg={12}>
						<p className='howItWorksText'>
							The Inside Injuries Health Score helps you understand which teams, position groups or players are healthier than others, based on the frequency, severity of their injuries as well as other factors. This data will help you make better, more accurate decisions in wagering, setting fantasy sports lineups or any other outcome-related
							activities.
						</p>
					</Col>
					{showSportsInfo ? <Legend /> : null}
				</Row>
				<hr id='cardSection' className='hrStyle' />
			</section>

			{/* 3. Scoreboard Section (Winning Percentage, Correct Picks, etc.) */}
			{nflPage && (
				<BreakingNews
				newsItems={schedules?.data?.AggregatedNews ? schedules?.data?.AggregatedNews : []}
				sportID={1}
				buttonText="See More"
				title={'Breaking NFL News'}
				logo={nfllogo}
			/>
			)}
			{
				(nbaPage || cricketPage) && (
					<BreakingNews
					newsItems={schedules?.data?.AggregatedNews ? schedules?.data?.AggregatedNews : []}
					hasMore={
						cricketPage
							? Boolean(schedules?.data?.newsPagination?.hasMore) || ((schedules?.data?.AggregatedNews || []).length >= 6)
							: Boolean(schedules?.data?.newsPagination?.hasMore)
					}
					buttonText="See More"
					title={cricketPage ? 'Breaking IPL News' : 'Breaking NBA News'}
					logo={cricketPage ? cricketLogo : nbalogo}
					sportID={cricketPage ? 4 : 2}
					pageSize={cricketPage ? 6 : 5}
					onLoadMore={cricketPage ? loadMoreCricketNews : undefined}
				/>
				)
			}
			

			{!user?.login && (nbaPage) ? (
				<>
					<div className='landingPageCoverDiv'>
						<div className='landingPageCoverHeaderDiv'>
							<h1 className='landingPageCoverHeader'>{cricketPage ? 'Your Destination for IPL Injury Insights' : 'Your Destination for NBA Injury Insights'}</h1>
							<p className='landingPageCoverText'>The missing piece to your DFS strategy.</p>
						</div>
						<img src={landingCoverImg} alt={landingCoverAlt} className='landingPageCoverImg' />
						<div className='landingPageCoverImgDiv' style={{ backgroundImage: `url(${landingCoverImg})` }}>
							<div className='landingPageCoverInsightDiv'>
								<p className='landingPageCoverInsightPart'>SHOULDER</p>
								<div className='landingPageCoverInsightSmallCircle' />
								<div className='landingPageCoverInsightLine' />
								<div className='landingPageCoverInsightBigCircle' />
							</div>
							<div className='landingPageCoverSignupDiv'>
								<h3 className='landingPageCoverSignupHeader'>
									Pinpoint which players
									<br />
									are set to shine in your
									<br />
									lineup.
								</h3>
								<Button
									className='signupButton homeCoverSignupButton'
									onClick={() => {
										dispatch({
											type: 'AUDIT',
											payload: { action: 'SIGNUP' }
										});
										Event(sources?.source, 'CLICK_SIGNUP', 'DASHBOARD_SIGNUP_BUTTON');
									}}
									href='/signup'
								>
									JOIN FOR FREE
								</Button>
							</div>
						</div>
					</div>
				</>
			) : null}
			{!user?.login && cricketPage ? (
				<>
					<div className='landingPageCoverDiv sportsCoverDiv'>
						<div className='landingPageCoverHeaderDiv'>
							<h1 className='landingPageCoverHeader'>{cricketPage ? 'Your Destination for IPL Injury Insights' : 'Your Destination for NBA Injury Insights'}</h1>
							<p className='landingPageCoverText'>The missing piece to your DFS strategy.</p>
						</div>
						<img src={CKCoverImg} alt={landingCoverAlt} className='landingPageCoverImg' />
						<div className='landingPageCoverImgDiv' style={{ backgroundImage: `url(${CKCoverImg})` }}>
							<div className='landingPageCoverInsightDiv'>
								<p className='landingPageCoverInsightPart'>SHOULDER</p>
								<div className='landingPageCoverInsightSmallCircle' />
								<div className='landingPageCoverInsightLine' />
								<div className='landingPageCoverInsightBigCircle' />
							</div>
							<div className='landingPageCoverSignupDiv'>
								<h3 className='landingPageCoverSignupHeader'>
									Pinpoint which players
									<br />
									are set to shine in your
									<br />
									lineup.
								</h3>
								<Button
									className='signupButton homeCoverSignupButton'
									onClick={() => {
										dispatch({
											type: 'AUDIT',
											payload: { action: 'SIGNUP' }
										});
										Event(sources?.source, 'CLICK_SIGNUP', 'DASHBOARD_SIGNUP_BUTTON');
									}}
									href='/signup'
								>
									JOIN FOR FREE
								</Button>
							</div>
						</div>
					</div>
				</>
			) : null}

			<div className='mobileUserheader'>{user && user.name && <UserHeader username={user.name} title={title} />}</div>
		</div>
	);
}

const mapStateToProps = (state) => ({
	isLoading: state.isLoading,
	isLoaded: state.isLoaded,
	freeAccess: state.freeAccess,
	options: state.options,
	schedules: state.schedules,
	teams: state.teams,
	playersInfo: state.playersInfo,
	match: state.match,
	user: state.user,
	purchasePlan: state.purchasePlan,
	sources: state.sources,
	prices: state.prices,
});

export default connect(mapStateToProps)(UpcomingGames);
